import { Link } from "react-router";
import { CONSTANTS } from "../../constants";

const UnauthorizedPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen text-center">
      <h1 className="text-4xl sm:text-6xl mb-4 text-red-600">
        אין לך הרשאה מתאימה
      </h1>
      <p className="text-lg text-gray-600">אין לך גישה לדף זה</p>
      <Link
        to={CONSTANTS.ROUTES.home}
        className="mt-6 text-blue-500 rounded border border-blue-500 px-4 py-4 hover:scale-110">
        חזור למסך הבית
      </Link>
    </div>
  );
};

export default UnauthorizedPage;
